import React from 'react';
import { RouteProp } from '@react-navigation/native';
import { ResourcesTabParamList, useGoBack, useResourcesTabNavigation } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import useOrganizationCareTeamMembers from '../../../../../hooks/api/useOrganizationCareTeamMembers';
import OrganizationCareTeamMemberDetails from '../../../../shared/OrganizationCareTeamMember/OrganizationCareTeamMemberDetails';
import { useIsOrganizationAdmin } from '../../../../../hooks/api/useOrganization';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import { getIntl } from '../../../../../utils/intl';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';

const intl = getIntl('organization-care-team-screen', {
    delete: 'Delete',
    edit: 'Edit',
});

export type CareTeamMemberOwnProps = {};

export type CareTeamMemberNavigatorProps = {
    route: RouteProp<ResourcesTabParamList, 'edit-care-team-member'>;
};

export type CareTeamMemberProps = CareTeamMemberOwnProps & CareTeamMemberNavigatorProps;

const AddCareTeamMember: React.FC<CareTeamMemberProps> = ({ route }) => {
    const goBack = useGoBack();
    const resourcesTabNavigation = useResourcesTabNavigation();
    const { organizationCareTeamMember, isLoadingOrganizationCareTeamMember, deleteCareTeamMember } =
        useOrganizationCareTeamMembers({
            organizationCareTeamMemberId: route.params.careTeamMemberId,
            onDeleteCareTeamMember: goBack,
        });
    const isAdmin = useIsOrganizationAdmin();

    return (
        <AnimateLoadedContent isLoading={isLoadingOrganizationCareTeamMember || !organizationCareTeamMember}>
            {() => (
                <ActionButtonLayout
                    scrollable
                    actions={[
                        {
                            title: intl('edit'),
                            onPress: () => {
                                resourcesTabNavigation.navigate('edit-care-team-member', {
                                    careTeamMemberId: route.params.careTeamMemberId,
                                });
                            },
                            testID: 'edit-care-team-member-button',
                            icon: 'Edit2',
                        },
                        {
                            title: intl('delete'),
                            onPress: () => {
                                deleteCareTeamMember(route.params.careTeamMemberId);
                                goBack();
                            },
                            isDisabled: !isAdmin,
                            testID: 'delete-care-team-member-button',
                            icon: 'Trash2',
                        },
                    ]}
                >
                    <MainContentContainer>
                        <OrganizationCareTeamMemberDetails
                            organizationCareTeamMemberId={route.params.careTeamMemberId}
                            organizationCareTeamMember={organizationCareTeamMember!}
                        />
                    </MainContentContainer>
                </ActionButtonLayout>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddCareTeamMember);
